import $ from 'jquery'

// Open external links in a separate tab
$(document.links).filter(function() {
    return this.hostname != window.location.hostname;
  }).attr('target', '_blank');

// Open PDF files in an external tab
$("a[target!='_blank'][href$='.pdf']").attr("target", "_blank");
